import { assertInInjectionContext, inject, InjectionToken } from '@angular/core';
import { ShellEnvironment } from './shell.constants';

export const SOFTLINE_TOKEN_SHELL_ENVIRONMENT = new InjectionToken<
  ShellEnvironment | undefined
>('SOFTLINE_TOKEN_SHELL_ENVIRONMENT', {
  factory: () => undefined,
});

export function injectShellEnvironment(): ShellEnvironment | undefined {
  assertInInjectionContext(injectShellEnvironment);
  const environment = inject(SOFTLINE_TOKEN_SHELL_ENVIRONMENT, { optional: true });
  return environment ?? undefined;
}

export function isEmbeddedShellEnvironment(
  environment: ShellEnvironment | string | undefined
): environment is typeof ShellEnvironment.EMBEDDED {
  return environment === ShellEnvironment.EMBEDDED;
}

export function isPublicShellEnvironment(
  environment: ShellEnvironment | string | undefined
): environment is typeof ShellEnvironment.PUBLIC {
  return environment === ShellEnvironment.PUBLIC;
}

export function isDefaultShellEnvironment(
  environment: ShellEnvironment | string | undefined
): environment is typeof ShellEnvironment.DEFAULT {
  return environment === ShellEnvironment.DEFAULT;
}

export function isTerminalShellEnvironment(
  environment: ShellEnvironment | string | undefined
): environment is typeof ShellEnvironment.TERMINAL {
  return environment === ShellEnvironment.TERMINAL;
}

export function isShellEnvironment(
  environment: ShellEnvironment | string | null | undefined
) {
  if (!environment) return false;

  return (
    isPublicShellEnvironment(environment) ||
    isDefaultShellEnvironment(environment) ||
    isEmbeddedShellEnvironment(environment) ||
    isTerminalShellEnvironment(environment)
  );
}
